"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ROLES = exports.NANI_CLUB_REDIRECT_PATH = exports.LOGIN_PATH = exports.EDUCATIONAL = exports.DATEFORMAT = exports.COOKIE_NANI_LOGIN_TOKEN_NAME = exports.COOKIE_LOGIN_TOKEN_NAME = void 0;
/** 平台 token：用 OneClub / Nani Club 的 JWT 跟 resource-platform 換來的 */
const COOKIE_LOGIN_TOKEN_NAME = exports.COOKIE_LOGIN_TOKEN_NAME = "nani_oneclass_resource_platform_token";

/** 會員 JWT */
const COOKIE_NANI_LOGIN_TOKEN_NAME = exports.COOKIE_NANI_LOGIN_TOKEN_NAME = "nani_oneclass_login_token";
const LOGIN_PATH = exports.LOGIN_PATH = "/login";
const NANI_CLUB_REDIRECT_PATH = exports.NANI_CLUB_REDIRECT_PATH = "/naniClubRedirect";
const ROLES = exports.ROLES = {
  Editor: "編輯",
  Guest: "訪客"
};
const EDUCATIONAL = exports.EDUCATIONAL = [{
  name: "國小",
  value: "E"
}, {
  name: "國中",
  value: "J"
}, {
  name: "高中",
  value: "H"
}];
const DATEFORMAT = exports.DATEFORMAT = "YYYY-MM-DD";